import { CustomTypeOptions } from 'react-i18next';

import faqTranslation from './faq.json';
import globalFaqTranslation from './faq_global.json';
import inniFaqTranslation from './faq_inni.json';

export interface QuestionAnswer {
  question: string;
  answer: string;
}

export interface Faq {
  title: string;
  qas: QuestionAnswer[];
}

export const faqData: Record<keyof CustomTypeOptions['resources'], Faq[]> =
  faqTranslation;

export const globalFaqData: Record<
  keyof CustomTypeOptions['resources'],
  Faq[]
> = globalFaqTranslation;

export const inniFaqData: Record<keyof CustomTypeOptions['resources'], Faq[]> =
  inniFaqTranslation;
